const apiV2Server =
  process.env.REACT_APP_apiV2Server || 'http://localhost:4000/api/v2/';

const defaultAPI = {
  getRetryDeliveryParcel: {
    apiServer: apiV2Server,
    path: 'parcels/retryDelivery/parcel/:id:',
    method: 'GET'
  },
  updateRetryDeliveryParcel: {
    apiServer: apiV2Server,
    path: 'parcels/retryDelivery/parcel/:id:',
    method: 'PUT',
    headers: [{ 'Content-Type': 'application/json' }]
  },
  collectRetryDeliveryParcel: {
    apiServer: apiV2Server,
    path: 'parcels/retryDelivery/parcel/:id:/collect',
    method: 'POST',
    headers: [{ 'Content-Type': 'application/json' }]
  },
  getChangePudoPointParcel: {
    apiServer: apiV2Server,
    path: 'parcels/changePudoPoint/parcel/:id:',
    method: 'GET'
  },
  updateChangePudoPointParcel: {
    apiServer: apiV2Server,
    path: 'parcels/changePudoPoint/parcel/:id:',
    method: 'PUT',
    headers: [{ 'Content-Type': 'application/json' }]
  },
  collectChangePudoPointParcel: {
    apiServer: apiV2Server,
    path: 'parcels/changePudoPoint/parcel/:id:/collect',
    method: 'POST',
    headers: [{ 'Content-Type': 'application/json' }]
  },
  getUpgradeDeliveryParcel: {
    apiServer: apiV2Server,
    path: 'parcels/upgradeDelivery/parcel/:id:',
    method: 'GET'
  },
  updateUpgradeDeliveryParcel: {
    apiServer: apiV2Server,
    path: 'parcels/upgradeDelivery/parcel/:id:',
    method: 'PUT',
    headers: [{ 'Content-Type': 'application/json' }]
  },
  collectUpgradeDeliveryParcel: {
    apiServer: apiV2Server,
    path: 'parcels/upgradeDelivery/parcel/:id:/collect',
    method: 'POST',
    headers: [{ 'Content-Type': 'application/json' }]
  },
  getPayDutiesParcel: {
    apiServer: apiV2Server,
    path: 'parcels/fromSMS/payDuties/parcel/:id:',
    method: 'GET'
  },
  updatePayDutiesParcel: {
    apiServer: apiV2Server,
    path: 'parcels/fromSMS/payDuties/parcel/:id:',
    method: 'PUT',
    headers: [{ 'Content-Type': 'application/json' }]
  },
  collectPayDutiesParcel: {
    apiServer: apiV2Server,
    path: 'parcels/fromSMS/payDuties/parcel/:id:/collect',
    method: 'POST',
    headers: [{ 'Content-Type': 'application/json' }]
  },
  getPayInspectionParcel: {
    apiServer: apiV2Server,
    path: 'parcels/fromSMS/payInspection/parcel/:id:',
    method: 'GET'
  },
  updatePayInspectionParcel: {
    apiServer: apiV2Server,
    path: 'parcels/fromSMS/payInspection/parcel/:id:',
    method: 'PUT',
    headers: [{ 'Content-Type': 'application/json' }]
  },
  collectPayInspectionParcel: {
    apiServer: apiV2Server,
    path: 'parcels/fromSMS/payInspection/parcel/:id:/collect',
    method: 'POST',
    headers: [{ 'Content-Type': 'application/json' }]
  },
  getMissingIDParcel: {
    apiServer: apiV2Server,
    path: 'parcels/missingID/parcel/:id:',
    method: 'GET'
  },
  updateMissingIDParcel: {
    apiServer: apiV2Server,
    path: 'parcels/missingID/parcel/:id:',
    method: 'PUT',
    headers: [{ 'Content-Type': 'application/json' }]
  },
  collectMissingIDParcel: {
    apiServer: apiV2Server,
    path: 'parcels/missingID/parcel/:id:/collect',
    method: 'POST',
    headers: [{ 'Content-Type': 'application/json' }]
  },
  /** Generic SMS fee payment (parcels/payments/:page/parcel/:id — see config/smsFeePaymentPages.js) */
  getSmsFeePaymentParcel: {
    apiServer: apiV2Server,
    path: 'parcels/payments/:page:/parcel/:id:',
    method: 'GET'
  },
  updateSmsFeePaymentParcel: {
    apiServer: apiV2Server,
    path: 'parcels/payments/:page:/parcel/:id:',
    method: 'PUT',
    headers: [{ 'Content-Type': 'application/json' }]
  },
  collectSmsFeePaymentParcel: {
    apiServer: apiV2Server,
    path: 'parcels/payments/:page:/parcel/:id:/collect',
    method: 'POST',
    headers: [{ 'Content-Type': 'application/json' }]
  },
  addPageLog: {
    apiServer: apiV2Server,
    path: 'parcels/fromSMS/payInspection/parcel/:id:/pageLog',
    method: 'PUT',
    headers: [{ 'Content-Type': 'application/json' }]
  },
  getPublicMetadata: {
    apiServer: apiV2Server,
    path: 'public_metadata',
    method: 'GET'
  },
  updateParcelBySMS: {
    apiServer: apiV2Server,
    path: 'parcels/fromSMS/parcel/:id:',
    method: 'PUT',
    headers: [{ 'Content-Type': 'application/json' }]
  },
  getParcelBySMS: {
    apiServer: apiV2Server,
    path: 'parcels/fromSMS/parcel/:id:',
    method: 'GET',
    headers: [{ 'Content-Type': 'application/json' }]
  },
  processCreditGuardPublicPayment: {
    apiServer: apiV2Server,
    path: 'parcels/creditguard/process_payment/:status:',
    method: 'POST',
    headers: [{ 'Content-Type': 'application/json' }]
  },
  updateSmsServicesOpt: {
    apiServer: apiV2Server,
    path: 'sms/servicesOpt/:id:/:type:',
    method: 'PUT'
  },
  getCommunicationData: {
    apiServer: apiV2Server,
    path: 'sms/smsServicesOpt/:id:/:type:',
    method: 'GET'
  },
  getBuyerPersonalDetails: {
    apiServer: apiV2Server,
    path: 'parcels/parcel/:id:/buyerInfo',
    method: 'GET'
  },
  updateBuyerPersonalDetails: {
    apiServer: apiV2Server,
    path: 'parcels/parcel/:id:/buyerInfo',
    method: 'PUT',
    headers: [{ 'Content-Type': 'application/json' }]
  },
  getFormURL: {
    apiServer: apiV2Server,
    path: 'parcels/parcel/:id:/forms/:formID:',
    method: 'GET'
  },
  updateFilledFormsURL: {
    apiServer: apiV2Server,
    path: 'parcels/forms/:formID:',
    method: 'PUT'
  },
};

export function api(state = defaultAPI) {
  return state;
}
